import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import cx from 'classnames';
import { type BlockEditProps } from '@plone/types';

declare module '@plone/types' {
  interface ContainedItem {
    active?: boolean;
    id?: string;
    exclude_from_nav?: boolean;
  }
}

export type MenuItem =
  | (BlockEditProps['properties']['items'][number] & {
      active?: boolean;
      id?: string;
    })
  | {
      active?: boolean;
      id?: string;
      title: string;
    };

type Props = {
  items: MenuItem[];
  isEditMode?: boolean;
};

export default function ViewItem({ items, isEditMode }: Props) {
  return (
    <nav className="product-menu">
      <ul>
        {items.map((item) => {
          return (
            <li
              className={cx({ active: item.active })}
              key={item.id}
              contentEditable={false}
            >
              {/* @ts-expect-error */}
              <ConditionalLink
                condition={!isEditMode}
                item={item}
                openLinkInNewTab={false}
              >
                {item.title}
              </ConditionalLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
